import { getTrackingData } from '@teko/tracking';
import { styled, ButtonChevron } from '@teko/ui';
import React, { useState, useRef, useImperativeHandle, useEffect } from 'react';
import { getElementOffset } from '../../helpers/index.es.js';
import { t } from '../../i18n.es.js';
import { Specifications } from '../../ProductDetail/ProductSpecifications/Specifications/Specifications.es.js';
import { BlockHeader } from '../BlockHeader/BlockHeader.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled.div`
  background-color: #fff;
  position: relative;
  border-radius: 8px;
`;
const Content = styled.div(({ maxHeight, showMoreNeeded }) => `
  background-color: #fff;
  height: fit-content;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  position: relative;
  ${showMoreNeeded ? "" : `
  &:after {
    content: ' ';
    background: linear-gradient(transparent, hsla(0, 0%, 100%, 0) 70%, #fff 90%);
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255));
    position: absolute;
    bottom: 0;
    height: 40px;
    width: 100%;
  }
  max-height: ${maxHeight}px;
  padding-bottom: 14px;
  `}
`);
const ShowMore = styled(ButtonChevron)`
  border-radius: 0;
  justify-content: center;
  padding: 14px 0;
  color: ${({ showArrow }) => showArrow ? "#848788" : "#0300BE"};
  width: calc(100% - 32px);
  margin-left: 16px;
  span {
    margin-left: 4px;
  }
`;
const HEADER_HEIGHT = 72;
const HEADING_HEIGHT = 56;
const ProductSpecificationsMobile = React.forwardRef((_a, forwardedRef) => {
  var _b = _a, {
    attributeGroups,
    maxHeight,
    expandLabel = t("Xem th\xEAm"),
    collapseLabel = t("Thu g\u1ECDn"),
    className,
    moveTop = true,
    title = t("Th\xF4ng s\u1ED1 k\u1EF9 thu\u1EADt"),
    isHideTitle = false,
    maxItemPerView
  } = _b, others = __objRest(_b, [
    "attributeGroups",
    "maxHeight",
    "expandLabel",
    "collapseLabel",
    "className",
    "moveTop",
    "title",
    "isHideTitle",
    "maxItemPerView"
  ]);
  const [showMoreNeeded, setShowMoreNeeded] = useState(false);
  const descriptionRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  useImperativeHandle(forwardedRef, () => descriptionRef.current);
  useEffect(() => {
    if (descriptionRef && descriptionRef.current && !maxItemPerView) {
      const element = descriptionRef.current;
      setShowMoreNeeded(element.clientHeight < element.scrollHeight);
    }
  }, [descriptionRef]);
  useEffect(() => {
    if (!!maxItemPerView && (attributeGroups == null ? void 0 : attributeGroups.length) > maxItemPerView) {
      setShowMoreNeeded(true);
    }
  }, [maxItemPerView, attributeGroups]);
  const handleClick = () => {
    setExpanded((prev) => {
      if (prev && moveTop && descriptionRef && descriptionRef.current) {
        const element = descriptionRef.current;
        window.scrollTo({
          left: 0,
          top: getElementOffset(element).top - HEADER_HEIGHT - HEADING_HEIGHT
        });
      }
      return !prev;
    });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({
    className
  }, others), !isHideTitle && /* @__PURE__ */ React.createElement(BlockHeader, {
    title: {
      fontSize: 16,
      fontWeight: "500",
      paddingTop: 1
    },
    hasDivider: true
  }, title), /* @__PURE__ */ React.createElement(Content, {
    ref: descriptionRef,
    maxHeight,
    showMoreNeeded: expanded
  }, /* @__PURE__ */ React.createElement(Specifications, {
    attributeGroups: !maxItemPerView ? attributeGroups : expanded ? attributeGroups : attributeGroups.slice(0, maxItemPerView),
    isDiplayFullAttribute: isHideTitle
  })), showMoreNeeded && /* @__PURE__ */ React.createElement("div", __spreadValues({}, getTrackingData({
    isTrackContent: true,
    regionName: "specificationDetail",
    contentName: "viewMore",
    target: "productAttributeGroups"
  })), /* @__PURE__ */ React.createElement(ShowMore, {
    block: true,
    link: true,
    direction: expanded ? "up" : "down",
    onClick: handleClick,
    showArrow: !isHideTitle
  }, expanded ? collapseLabel : expandLabel))));
});
ProductSpecificationsMobile.displayName = "ProductSpecificationsMobile";

export { ProductSpecificationsMobile };
